import React, { useEffect, useState, useRef } from "react";
import MapComponent from "../common-pointr-map-container/GenericPointrMapContainer"
import LeftContainer from "../left-container/left-container";
import HeaderContainer from "../header-container/header-container";
import RightContainer from "../right-container/right-container";
import SearchPopup from '../main-container/SearchPopup'; // Import SearchPopup component
import FooterContainer from '../footer-container/footer-container';
import { useMap } from '../../../context/MapContext'; // Import the useMap hook
import { useLocation } from 'react-router-dom'; // Import useLocation hook
import { handleReset } from '../main-container/handleResetView'; // Import the functions
import { calculateMidPoint, manageLayers,markCurrentPosition, removeCurrentPosition } from '../main-container/markCurrentPosition'; // Import the functions
import { fetchGsxData } from '../left-container/fetchZonesHubwalksInfo';
import CustomPopup from '../main-container/DirectionPopup';
import ciscoSpacesPopupIcon from '../../../../assets/images/powered-by-spaces-cl-emea.png';
import Screensaver from "../countdown-timer-container/screensaver";
import ciscoSpacesPopupImage from '../../../../assets/images/cisco-space-popup-cl-emea.png';
import {handleWhereAmI} from '../footer-container/handle-where-am-i';  
import ciscoAILogo from '../../../../assets/images/ai/ai-logo.svg';
import ciscoAIQrPlaceHolderLogo from '../../../../assets/images/ai/qr-code-place-holder.svg';
import ciscoAIQrPlaceHolderFailedLogo from '../../../../assets/images/ai/qr-code-place-holder-failed.svg';

import ciscoClosebutton from '../../../../assets/images/close-button.svg';
import ciscoHelpbutton from '../../../../assets/images/ai/help-icon.svg';
import CiscoAiAuth from '../right-container/ciscoAiAuth';
import {fetchAttendeeInfo, fetchRecommendedEvents} from '../right-container/ciscoAiApis';
import { TeaLogService,TeaLogModule } from '@events/tealium';
import {initializeXAPIScanner, getHashes} from '../qr-code-scanner-component/qr-code-scanner';
import AIFAQListContainer from "../right-container/ai-faq-list";
import {sendTrackingEventForCiscoAI} from "../main-container/pendoApis"
import LeftContainerNM from "../left-container-nm/left-container-nm";
const NMDemoMainContainer = () => {
  const kioskData = {
    "1": {
      "lat":  42.18882997249821,
      "long":  -71.20129185010097,
      "rotation": 1.5,
      "bearing": -83.8,
      "building": 8,
      "level":0
    },
    "2": {
      "lat": 42.18882997249821,
      "long": 4.889270989661952,
      "rotation": 1.5,
      "bearing": -83.5,
      "building": 8,
      "level":0
    }
  };
  
  const { map } = useMap();
  const teaLogService = new TeaLogService();

  const [isActive, setIsActive] = useState(true);
  const [timer, setTimer] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [isZonesInfoPopulated, setIsZonesInfoPopulated] = useState(false);

  const [zonesInfo, setZonesInfo] = useState([]);
  const [hubwalksInfo, setHubwalksInfo] = useState([]);
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [recommendationsInfo, setRecommendationsInfo] = useState([]);
  const [attendeeUserToken, setAttendeeUserToken] = useState([]);
  const [attendeeInfo, setAttendeeInfo] = useState([]);

  const hasPassedDestFidRef = useRef(false);

  const timerRef = useRef(null);
  const [popupState, setPopupState] = useState({ poi: null, coordinates: null }); // Add state for the popup
  const [ciscoSpacesPopup, setCiscoSpacesPopup] = useState(false);
  const [showPopupCard, setShowPopupCard] = useState(false);
  const [showFaqList, setShowFaqList] = useState(false);
  const [qrScanBadgeInfoInput, setQRScanBadgeInfoInput] = useState(null);
  const [aiLoader, showAiLoader] = useState(false);
  const [showFailedPopupCard, setShowFailedPopupCard] = useState(false);

  
  
  const [showAICard, setShowAICard] = useState(false);

  const [isPointrSDKLoaded, setIsPointrSDKLoaded] = useState(false); // State to track Pointr SDK load status
  const [triggerDirectionsPopup, setTriggerDirectionsPopup] = useState(false);

  const tenantId = "363252";
  const locationId = "24486742-de86-485d-83ca-e490fc345db7";
  const siteExternalIdentifier = "24486742-de86-485d-83ca-e490fc345db7";
  const timeZoneCity = "Chicago";
  const timeZone = "America/Chicago";
  const qrCodeExpiresAt = 1746057599 
  const eventLogoName = "nm.svg"
  const eventName = "NM-DEMO"
  const eventId="ds1ciscolive25emea";
  const eventTitle = "NM"
  const defaultBuildingTitle = "Cisco - NM"


  
  const eventSubTitle = ""

  const buildingInfo =  [
    {
      "buildingTitle": "Feinberg-Galter",
      "buildingInternalIdentifier": 19,
      "buildingExternalIdentifier": "88b004e2-8236-4740-81cd-e984fc573a0a",
      "buildingExtraData": {
          "timeZone": "America/Chicago"
      },
      "geometry": {
          "type": "Polygon",
          "coordinates": [
              [
                  [
                      -87.62278746,
                      41.89458997
                  ],
                  [
                      -87.6225972,
                      41.89459296
                  ],
                  [
                      -87.62260524,
                      41.89487045
                  ],
                  [
                      -87.62260435,
                      41.89487047
                  ],
                  [
                      -87.62260447,
                      41.89487374
                  ],
                  [
                      -87.62259733,
                      41.8948739
                  ],
                  [
                      -87.6225974,
                      41.8948762
                  ],
                  [
                      -87.62235096,
                      41.89487937
                  ],
                  [
                      -87.62192551,
                      41.89488881
                  ],
                  [
                      -87.62192532,
                      41.89488483
                  ],
                  [
                      -87.62191572,
                      41.89488495
                  ],
                  [
                      -87.62191566,
                      41.89488171
                  ],
                  [
                      -87.62189097,
                      41.8948821
                  ],
                  [
                      -87.62189104,
                      41.89488465
                  ],
                  [
                      -87.62184172,
                      41.89488542
                  ],
                  [
                      -87.62184165,
                      41.89488288
                  ],
                  [
                      -87.62163009,
                      41.89488619
                  ],
                  [
                      -87.62163046,
                      41.89489917
                  ],
                  [
                      -87.62164214,
                      41.89489898
                  ],
                  [
                      -87.62164215,
                      41.89489924
                  ],
                  [
                      -87.62164418,
                      41.89489921
                  ],
                  [
                      -87.62164418,
                      41.89489921
                  ],
                  [
                      -87.621649,
                      41.89506954
                  ],
                  [
                      -87.621649,
                      41.89506954
                  ],
                  [
                      -87.621647,
                      41.89506957
                  ],
                  [
                      -87.62164699,
                      41.89506959
                  ],
                  [
                      -87.62167924,
                      41.89509261
                  ],
                  [
                      -87.62258202,
                      41.89507846
                  ],
                  [
                      -87.62259871,
                      41.89566843
                  ],
                  [
                      -87.62160151,
                      41.89568406
                  ],
                  [
                      -87.6216017,
                      41.89569059
                  ],
                  [
                      -87.62156986,
                      41.89572008
                  ],
                  [
                      -87.62156807,
                      41.89571901
                  ],
                  [
                      -87.62155451,
                      41.89573156
                  ],
                  [
                      -87.62141669,
                      41.89573372
                  ],
                  [
                      -87.62131598,
                      41.89581192
                  ],
                  [
                      -87.62131668,
                      41.89583641
                  ],
                  [
                      -87.62131537,
                      41.89583643
                  ],
                  [
                      -87.6212842,
                      41.89583692
                  ],
                  [
                      -87.62128175,
                      41.89583696
                  ],
                  [
                      -87.62127851,
                      41.89583701
                  ],
                  [
                      -87.6212499,
                      41.89583746
                  ],
                  [
                      -87.62124986,
                      41.89583746
                  ],
                  [
                      -87.62124981,
                      41.89583746
                  ],
                  [
                      -87.62124766,
                      41.8958375
                  ],
                  [
                      -87.62124666,
                      41.89580236
                  ],
                  [
                      -87.62126822,
                      41.89577356
                  ],
                  [
                      -87.62130909,
                      41.89573213
                  ],
                  [
                      -87.62132078,
                      41.89571925
                  ],
                  [
                      -87.62133378,
                      41.89570164
                  ],
                  [
                      -87.62134489,
                      41.8956866
                  ],
                  [
                      -87.62146203,
                      41.89568476
                  ],
                  [
                      -87.62150096,
                      41.89568415
                  ],
                  [
                      -87.6215046,
                      41.89568078
                  ],
                  [
                      -87.62150257,
                      41.89567956
                  ],
                  [
                      -87.62153714,
                      41.89564756
                  ],
                  [
                      -87.62152601,
                      41.89525436
                  ],
                  [
                      -87.62155774,
                      41.89522973
                  ],
                  [
                      -87.62155342,
                      41.89507697
                  ],
                  [
                      -87.62155971,
                      41.89507687
                  ],
                  [
                      -87.6215602,
                      41.89509447
                  ],
                  [
                      -87.62157173,
                      41.89509429
                  ],
                  [
                      -87.62157083,
                      41.89509276
                  ],
                  [
                      -87.62156539,
                      41.89490045
                  ],
                  [
                      -87.62156616,
                      41.89490044
                  ],
                  [
                      -87.62156577,
                      41.89488666
                  ],
                  [
                      -87.62151234,
                      41.89488752
                  ],
                  [
                      -87.62151236,
                      41.89488804
                  ],
                  [
                      -87.6211518,
                      41.89489369
                  ],
                  [
                      -87.62115179,
                      41.89489327
                  ],
                  [
                      -87.62054257,
                      41.89490299
                  ],
                  [
                      -87.62054256,
                      41.89490278
                  ],
                  [
                      -87.6204745,
                      41.89490385
                  ],
                  [
                      -87.62045748,
                      41.89430235
                  ],
                  [
                      -87.62051642,
                      41.89430143
                  ],
                  [
                      -87.62051638,
                      41.8943004
                  ],
                  [
                      -87.62052012,
                      41.89430036
                  ],
                  [
                      -87.62052011,
                      41.89430004
                  ],
                  [
                      -87.62092941,
                      41.89429374
                  ],
                  [
                      -87.6209295,
                      41.8942945
                  ],
                  [
                      -87.62121636,
                      41.89429
                  ],
                  [
                      -87.62121639,
                      41.89428884
                  ],
                  [
                      -87.62153799,
                      41.89428496
                  ],
                  [
                      -87.62189456,
                      41.89427937
                  ],
                  [
                      -87.62189416,
                      41.89427293
                  ],
                  [
                      -87.62258146,
                      41.89426229
                  ],
                  [
                      -87.62258165,
                      41.89426728
                  ],
                  [
                      -87.62258777,
                      41.89426719
                  ],
                  [
                      -87.6225958,
                      41.89454453
                  ],
                  [
                      -87.62277455,
                      41.89454183
                  ],
                  [
                      -87.62277559,
                      41.89454566
                  ],
                  [
                      -87.62277559,
                      41.89454569
                  ],
                  [
                      -87.62278642,
                      41.89458609
                  ],
                  [
                      -87.62278643,
                      41.89458611
                  ],
                  [
                      -87.62278746,
                      41.89458997
                  ]
              ]
          ]
      },
      "levels": [
          {
              "levelShortTitle": "LD",
              "levelLongTitle": "Loading Dock",
              "levelIndex": -2,
              "levelExtraData": {
                  "levelExternalIdentifier": "026b8300-cbdc-4f20-9ac6-6a3c6c07d72d",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "LL",
              "levelLongTitle": "Feinberg-Galter Lower Level",
              "levelIndex": -1,
              "levelExtraData": {
                  "levelExternalIdentifier": "e68a453a-3d8d-4c89-bbe6-0626771fe811",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "1",
              "levelLongTitle": "Feinberg-Galter 1st Floor",
              "levelIndex": 0,
              "levelExtraData": {
                  "levelExternalIdentifier": "9d63fe5f-5ad5-4f6a-82c6-63a628112df0",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "M",
              "levelLongTitle": "Feinberg-Galter-MEZZANINE",
              "levelIndex": 1,
              "levelExtraData": {
                  "levelExternalIdentifier": "788cb57e-869b-4bd7-908b-ac9783423a17",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "2",
              "levelLongTitle": "Feinberg-Galter 2nd Floor",
              "levelIndex": 2,
              "levelExtraData": {
                  "levelExternalIdentifier": "ecc80007-5f8d-4ea9-a06b-6ae977d5865a",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "3",
              "levelLongTitle": "Feinberg-Galter 3nd Floor",
              "levelIndex": 3,
              "levelExtraData": {
                  "levelExternalIdentifier": "31b01c29-d59c-4167-8295-ab26a009f7b9",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "4",
              "levelLongTitle": "Feinberg-Galter 4th Floor",
              "levelIndex": 4,
              "levelExtraData": {
                  "levelExternalIdentifier": "83a5f535-a5ec-4b2d-b709-611b92bf7426",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "5",
              "levelLongTitle": "Feinberg-Galter 5th Floor",
              "levelIndex": 5,
              "levelExtraData": {
                  "levelExternalIdentifier": "b3273c58-4804-4c3a-bff2-43716b225032",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "6",
              "levelLongTitle": "Feinberg-Galter 6th Floor",
              "levelIndex": 6,
              "levelExtraData": {
                  "levelExternalIdentifier": "2ac91bc8-b898-4ccb-bc74-e3e3021a44b6",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "7",
              "levelLongTitle": "Feinberg-Galter 7th Floor",
              "levelIndex": 7,
              "levelExtraData": {
                  "levelExternalIdentifier": "a6866cd9-df30-44c5-9e56-098fbbf02bb8",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "8",
              "levelLongTitle": "Feinberg-Galter 8th Floor",
              "levelIndex": 8,
              "levelExtraData": {
                  "levelExternalIdentifier": "7701565b-b3f0-4012-8ef1-3869e3af26f4",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "9",
              "levelLongTitle": "Feinberg-Galter 9th Floor",
              "levelIndex": 9,
              "levelExtraData": {
                  "levelExternalIdentifier": "a78721af-af99-4275-a7f5-cbff2bb6f0fb",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "10",
              "levelLongTitle": "Feinberg-Galter 10th Floor",
              "levelIndex": 10,
              "levelExtraData": {
                  "levelExternalIdentifier": "25217d04-3c96-4e70-ac60-82929be10453",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "11",
              "levelLongTitle": "Feinberg-Galter 11th floor",
              "levelIndex": 11,
              "levelExtraData": {
                  "levelExternalIdentifier": "d7478d22-d4eb-4ed2-842b-b080e5980d68",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "12",
              "levelLongTitle": "Feinberg-Galter 12th Floor",
              "levelIndex": 12,
              "levelExtraData": {
                  "levelExternalIdentifier": "b40c5d47-cc04-4650-8d2e-e200f913e3be",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "13",
              "levelLongTitle": "Feinberg-Galter 13th Floor",
              "levelIndex": 13,
              "levelExtraData": {
                  "levelExternalIdentifier": "5819bf78-fcd1-44e5-ac3b-96bc3ca250a5",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "14",
              "levelLongTitle": "Feinberg-Galter 14th Floor",
              "levelIndex": 14,
              "levelExtraData": {
                  "levelExternalIdentifier": "6b4ad820-d34e-4b92-af72-c71fc80f572f",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "15",
              "levelLongTitle": "Feinberg-Galter 15th Floor",
              "levelIndex": 15,
              "levelExtraData": {
                  "levelExternalIdentifier": "64a070da-18d2-4ca6-b48d-8831927bd396",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "16",
              "levelLongTitle": "Feinberg-Galter 16th Floor",
              "levelIndex": 16,
              "levelExtraData": {
                  "levelExternalIdentifier": "57124a37-c630-4cf2-9b18-dda859368d1b",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "17",
              "levelLongTitle": "Feinberg-Galter 17th Floor",
              "levelIndex": 17,
              "levelExtraData": {
                  "levelExternalIdentifier": "d4a25e83-ee35-4cfe-92e8-bcbf44856182",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "18",
              "levelLongTitle": "Feinberg-Galter 18th Floor",
              "levelIndex": 18,
              "levelExtraData": {
                  "levelExternalIdentifier": "4931d0d5-a99d-400f-a591-e018f43023df",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "19",
              "levelLongTitle": "Feinberg-Galter 19th Floor",
              "levelIndex": 19,
              "levelExtraData": {
                  "levelExternalIdentifier": "b6eaf240-c0a2-4582-b03e-965541cb61ca",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "20",
              "levelLongTitle": "Feinberg-Galter 20th Floor",
              "levelIndex": 20,
              "levelExtraData": {
                  "levelExternalIdentifier": "29e9d9de-2d6a-4dc5-bad4-25b488629865",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "21",
              "levelLongTitle": "Feinberg-Galter 21st Floor",
              "levelIndex": 21,
              "levelExtraData": {
                  "levelExternalIdentifier": "8b546719-aa05-4cdb-bd83-9c6919e4cdc2",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "22",
              "levelLongTitle": "Feinberg-Galter 22nd Floor",
              "levelIndex": 22,
              "levelExtraData": {
                  "levelExternalIdentifier": "8adbf6b2-3e1c-4c10-b622-c3d65217be88",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "22M",
              "levelLongTitle": "Feinberg-Galter 22nd Mezz",
              "levelIndex": 23,
              "levelExtraData": {
                  "levelExternalIdentifier": "3b4bdd93-ac5e-41bc-b64d-b0727946acf9",
                  "timeZone": "America/Chicago"
              }
          },
          {
              "levelShortTitle": "23",
              "levelLongTitle": "Feinberg-Galter 23rd Floor",
              "levelIndex": 24,
              "levelExtraData": {
                  "levelExternalIdentifier": "9765e6f6-5ee1-4420-90d1-67a796d56485",
                  "timeZone": "America/Chicago"
              }
          }
      ]
  },
  {
    "buildingTitle": "222 E. Huron St. - Huron Parking Garage/16007",
    "buildingInternalIdentifier": 28,
    "buildingExternalIdentifier": "9571fd98-afee-4634-8814-43ffe5424fdb",
    "buildingExtraData": {
        "timeZone": "America/Chicago"
    },
    "geometry": {
        "type": "Polygon",
        "coordinates": [
            [
                [
                    -87.62266076,
                    41.89564382
                ],
                [
                    -87.62264341,
                    41.89564395
                ],
                [
                    -87.62264298,
                    41.89564396
                ],
                [
                    -87.62264325,
                    41.89566345
                ],
                [
                    -87.62264321,
                    41.89566345
                ],
                [
                    -87.62264322,
                    41.89566377
                ],
                [
                    -87.62264322,
                    41.89566377
                ],
                [
                    -87.62262134,
                    41.89566394
                ],
                [
                    -87.6226213,
                    41.89566394
                ],
                [
                    -87.62262125,
                    41.89566394
                ],
                [
                    -87.62260064,
                    41.8956641
                ],
                [
                    -87.62257817,
                    41.89566427
                ],
                [
                    -87.62257824,
                    41.89566976
                ],
                [
                    -87.62257713,
                    41.89566977
                ],
                [
                    -87.62257714,
                    41.89567008
                ],
                [
                    -87.62164256,
                    41.89567732
                ],
                [
                    -87.62164263,
                    41.895682
                ],
                [
                    -87.62159311,
                    41.89568238
                ],
                [
                    -87.62159305,
                    41.8956777
                ],
                [
                    -87.62157759,
                    41.89567782
                ],
                [
                    -87.62157139,
                    41.89523403
                ],
                [
                    -87.62156171,
                    41.89523411
                ],
                [
                    -87.62156168,
                    41.89523227
                ],
                [
                    -87.62156167,
                    41.89523227
                ],
                [
                    -87.62156023,
                    41.89512865
                ],
                [
                    -87.62156024,
                    41.89512865
                ],
                [
                    -87.62156024,
                    41.89512862
                ],
                [
                    -87.62156581,
                    41.89512858
                ],
                [
                    -87.62156545,
                    41.89510308
                ],
                [
                    -87.62156545,
                    41.89510308
                ],
                [
                    -87.62157217,
                    41.89510302
                ],
                [
                    -87.62156975,
                    41.8948704
                ],
                [
                    -87.62157291,
                    41.8948704
                ],
                [
                    -87.62162951,
                    41.89485757
                ],
                [
                    -87.62163267,
                    41.89485754
                ],
                [
                    -87.62163586,
                    41.89508239
                ],
                [
                    -87.62164599,
                    41.89508232
                ],
                [
                    -87.62165249,
                    41.89508227
                ],
                [
                    -87.62178386,
                    41.89508127
                ],
                [
                    -87.62178391,
                    41.89508127
                ],
                [
                    -87.62215461,
                    41.89507846
                ],
                [
                    -87.62249483,
                    41.89507588
                ],
                [
                    -87.62248741,
                    41.89484592
                ],
                [
                    -87.62249053,
                    41.89484587
                ],
                [
                    -87.62249058,
                    41.89484587
                ],
                [
                    -87.62249062,
                    41.89484587
                ],
                [
                    -87.62254702,
                    41.89484497
                ],
                [
                    -87.62254703,
                    41.89484497
                ],
                [
                    -87.62254707,
                    41.89484497
                ],
                [
                    -87.62255023,
                    41.89484493
                ],
                [
                    -87.62255473,
                    41.89507542
                ],
                [
                    -87.62256883,
                    41.89507531
                ],
                [
                    -87.62256883,
                    41.89507531
                ],
                [
                    -87.62256884,
                    41.8950759
                ],
                [
                    -87.62256989,
                    41.89507589
                ],
                [
                    -87.62256989,
                    41.89507589
                ],
                [
                    -87.62256994,
                    41.89507589
                ],
                [
                    -87.62257022,
                    41.8950953
                ],
                [
                    -87.62263527,
                    41.8950948
                ],
                [
                    -87.62263528,
                    41.89509572
                ],
                [
                    -87.6226353,
                    41.89509572
                ],
                [
                    -87.62263565,
                    41.8951203
                ],
                [
                    -87.62265343,
                    41.89512016
                ],
                [
                    -87.62265343,
                    41.89512016
                ],
                [
                    -87.62265344,
                    41.89512016
                ],
                [
                    -87.62265344,
                    41.89512019
                ],
                [
                    -87.62265378,
                    41.89512018
                ],
                [
                    -87.6226611,
                    41.89564376
                ],
                [
                    -87.62266076,
                    41.89564376
                ],
                [
                    -87.62266076,
                    41.89564382
                ]
            ]
        ]
    },
    "levels": [
        {
            "levelShortTitle": "G",
            "levelLongTitle": "222 - Ground Floor",
            "levelIndex": 1,
            "levelExtraData": {
                "levelExternalIdentifier": "0a974120-966c-49a7-a363-ab6d5135610d",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "2nd",
            "levelLongTitle": "222 - 2nd Floor",
            "levelIndex": 2,
            "levelExtraData": {
                "levelExternalIdentifier": "2f6e09b0-92ec-4bd3-934b-749d31b03d0e",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "3rd",
            "levelLongTitle": "222 - 3rd Floor",
            "levelIndex": 3,
            "levelExtraData": {
                "levelExternalIdentifier": "cdac26d8-c0c4-4219-b01f-8c8e7ae251df",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "4th",
            "levelLongTitle": "222 - 4th Floor",
            "levelIndex": 4,
            "levelExtraData": {
                "levelExternalIdentifier": "5f23b109-f2f2-4001-be83-e7d082f6bde9",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "5th",
            "levelLongTitle": "222 - 5th Floor",
            "levelIndex": 5,
            "levelExtraData": {
                "levelExternalIdentifier": "21be83ec-8f8d-41cd-91aa-06c8d6073528",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "6th",
            "levelLongTitle": "222 - 6th Floor",
            "levelIndex": 6,
            "levelExtraData": {
                "levelExternalIdentifier": "dbd7f40b-df34-4aaf-a2fc-8cb30ebc4f9d",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "7th",
            "levelLongTitle": "222 - 7th Floor",
            "levelIndex": 7,
            "levelExtraData": {
                "levelExternalIdentifier": "e03ae70d-7086-4e12-b888-4cfc6725d205",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "8th",
            "levelLongTitle": "222 - 8th Floor",
            "levelIndex": 8,
            "levelExtraData": {
                "levelExternalIdentifier": "1446839e-676f-432f-af3f-e9a25740289a",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "9th",
            "levelLongTitle": "222 - 9th Floor",
            "levelIndex": 9,
            "levelExtraData": {
                "levelExternalIdentifier": "212a1971-d2cb-4ea1-b2f6-0b6a0db9595b",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "10th",
            "levelLongTitle": "222 - 10th Floor",
            "levelIndex": 10,
            "levelExtraData": {
                "levelExternalIdentifier": "10b47e64-4e82-4da5-9b3d-acbdda8ec251",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "11th",
            "levelLongTitle": "222 - 11th Floor",
            "levelIndex": 11,
            "levelExtraData": {
                "levelExternalIdentifier": "25141465-d1a3-461d-bde9-38103f20a0f5",
                "timeZone": "America/Chicago"
            }
        },
        {
            "levelShortTitle": "12th",
            "levelLongTitle": "222 - 12th Floor",
            "levelIndex": 12,
            "levelExtraData": {
                "levelExternalIdentifier": "03590396-d41e-4a34-b6c4-efdf685827b6",
                "timeZone": "America/Chicago"
            }
        }
    ]
}
];
  // Or, if the keys are static, you can use an object:
  const buildingExID = {
    19: "88b004e2-8236-4740-81cd-e984fc573a0a",
    28:"9571fd98-afee-4634-8814-43ffe5424fdb"
  };

  const levelExId ={
    "88b004e2-8236-4740-81cd-e984fc573a0a": {
      '-2': "026b8300-cbdc-4f20-9ac6-6a3c6c07d72d",
      '-1': "e68a453a-3d8d-4c89-bbe6-0626771fe811",
      0: "9d63fe5f-5ad5-4f6a-82c6-63a628112df0",
      1: "788cb57e-869b-4bd7-908b-ac9783423a17",
      2: "ecc80007-5f8d-4ea9-a06b-6ae977d5865a",
      3: "31b01c29-d59c-4167-8295-ab26a009f7b9",
      4: "83a5f535-a5ec-4b2d-b709-611b92bf7426",
      5: "b3273c58-4804-4c3a-bff2-43716b225032",
      6: "2ac91bc8-b898-4ccb-bc74-e3e3021a44b6",
      7: "a6866cd9-df30-44c5-9e56-098fbbf02bb8",
      8: "7701565b-b3f0-4012-8ef1-3869e3af26f4",
      9: "a78721af-af99-4275-a7f5-cbff2bb6f0fb",
      10: "25217d04-3c96-4e70-ac60-82929be10453",
      11: "d7478d22-d4eb-4ed2-842b-b080e5980d68",
      12: "b40c5d47-cc04-4650-8d2e-e200f913e3be",
      13: "5819bf78-fcd1-44e5-ac3b-96bc3ca250a5",
      14: "6b4ad820-d34e-4b92-af72-c71fc80f572f",
      15: "64a070da-18d2-4ca6-b48d-8831927bd396",
      16: "57124a37-c630-4cf2-9b18-dda859368d1b",
      17: "d4a25e83-ee35-4cfe-92e8-bcbf44856182",
      18: "4931d0d5-a99d-400f-a591-e018f43023df",
      19: "b6eaf240-c0a2-4582-b03e-965541cb61ca",
      20: "29e9d9de-2d6a-4dc5-bad4-25b488629865",
      21: "8b546719-aa05-4cdb-bd83-9c6919e4cdc2",
      22: "8adbf6b2-3e1c-4c10-b622-c3d65217be88",
      23: "3b4bdd93-ac5e-41bc-b64d-b0727946acf9",
      24: "9765e6f6-5ee1-4420-90d1-67a796d56485"
    },
    "9571fd98-afee-4634-8814-43ffe5424fdb": {
      1: "0a974120-966c-49a7-a363-ab6d5135610d",
      2: "2f6e09b0-92ec-4bd3-934b-749d31b03d0e",
      3: "cdac26d8-c0c4-4219-b01f-8c8e7ae251df",
      4: "5f23b109-f2f2-4001-be83-e7d082f6bde9",
      5: "21be83ec-8f8d-41cd-91aa-06c8d6073528",
      6: "dbd7f40b-df34-4aaf-a2fc-8cb30ebc4f9d",
      7: "e03ae70d-7086-4e12-b888-4cfc6725d205",
      8: "1446839e-676f-432f-af3f-e9a25740289a",
      9: "212a1971-d2cb-4ea1-b2f6-0b6a0db9595b",
      10: "10b47e64-4e82-4da5-9b3d-acbdda8ec251",
      11: "25141465-d1a3-461d-bde9-38103f20a0f5",
      12: "03590396-d41e-4a34-b6c4-efdf685827b6",
    }
  }

  const minMaxBounds = [
    
    [ 4.874747373780906,
      52.32649719537784
    ],
    [
      4.900164974144076,
      52.35777235234855
    ]
  ];

 
  const floorColourMapping = [
    { levelIndex: -1, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: -2, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 0, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 1, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 2, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 3, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 4, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 5, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 6, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 7, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 8, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 9, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 10, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 11, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 12, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 13, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 14, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 15, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 16, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 17, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 18, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 19, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 20, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 21, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 22, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 23, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
    { levelIndex: 24, color: '#4F545A',fillColor:'#FFFFFF', enableDisplayBullet:false },
  ];


  const floorNameMapping = {
    '-1': '    Level -1',
    '-2': '    Level -2',
    0: 'Ground Floor',
    1: '    Level 1',
    2: '    Level 2',
    3: '    Level 3',
    4: '    Level 4',
    5: '    Level 5',
    6: '    Level 6',
    7: '    Level 7',
    8: '    Level 8',
    9: '    Level 9',
    10: '    Level 10', 
    11: '    Level 11',
    12: '    Level 12',
    13: '    Level 13',
    14: '    Level 14',
    15: '    Level 15',
    16: '    Level 16',
    17: '    Level 17',
    18: '    Level 18',
    19: '    Level 19',
    20: '    Level 20', 
    21: '    Level 21',
    22: '    Level 22', 
    23: '    Level 23',
    24: '    Level 24'
  };

  const constraintsLookUp = {
    "Full Conference": [
        "Full Conf - Schedule",
        "Explorer - Schedule"
    ],
    "Cisco Full Conference": [
        "Full Conf - Schedule",
        "Explorer - Schedule"
    ],
    "IT Leadership": [
        "Full Conf - Schedule",
        "Explorer - Schedule"
    ],
    "Explorer": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Cisco Explorer": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Cisco Thursday Explorer": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Thursday Explorer": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Cisco Wednesday Explorer": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Wednesday Explorer": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Event Staff": [
        "Full Conf - View"
    ],
    "Speaker Full Conference": [
        "Full Conf - View"
    ],
    "Cisco Explorer": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],

}  
 
  const getLocationId = (poi) => {
    const bid = poi?.properties?.bid;
    const lvl = poi?.properties?.lvl;
    const buildingId = buildingExID[bid];
  
    // Check if both buildingId and lvl exist in levelExId
    if (buildingId && lvl !== undefined && levelExId[buildingId]?.[lvl] !== undefined) {
      return levelExId[buildingId][lvl];
    }
  
    // Fallback to buildingId if lvl is not present or no match found
    return buildingId || locationId;
  };
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const kioskFid = query.get('kioskFid')||query.get('locationNum');
  const destFid = query.get('destFid');
  const latFromQuery = parseFloat(query.get('lat'));
  const longFromQuery = parseFloat(query.get('long'));
  const rotationFromQuery = parseFloat(query.get('rotation'));
  const zoomFromQuery = parseFloat(query.get('zoom'));
  const pitchFromQuery = parseFloat(query.get('pitch'));
  const bearingFromQuery = parseFloat(query.get('bearing'));
  const levelFromQuery = parseFloat(query.get('level'));
  const buildingFromQuery = parseFloat(query.get('building'));
  const visibleAiContainerFromQuery = query.get('enableAI');
  const eventStartDay = query.get('eventStartDay')?query.get('eventStartDay'):3;
   
  
  const centerLong = -87.62175027218564 ;
  const centerLat = 41.89460301448591;
  const whereAmIScale = 42.091301692798277e-8;
  const xapi=null;

  const [lat, setLat] = useState(kioskData[kioskFid]?.lat || (latFromQuery ? latFromQuery :  41.89455594867405));
  const [long, setLong] = useState(kioskData[kioskFid]?.long || (longFromQuery ? longFromQuery :  -87.62146578426504));
  const [rotation, setRotation] = useState(kioskData[kioskFid]?.rotation || (rotationFromQuery ? rotationFromQuery:0.1));
  const [zoom, setZoom] = useState(kioskData[kioskFid]?.zoom || (zoomFromQuery ? zoomFromQuery : 17));
  const [pitch, setPitch] = useState(kioskData[kioskFid]?.pitch || (pitchFromQuery ? pitchFromQuery: 65));
  const [bearing, setBearing] = useState(kioskData[kioskFid]?.bearing || (bearingFromQuery ? bearingFromQuery : 15));
  const [level, setLevel] = useState(kioskData[kioskFid]?.level || (levelFromQuery ? levelFromQuery: 3));
  const [building, setBuilding] = useState(kioskData[kioskFid]?.building || (buildingFromQuery ? buildingFromQuery : 12));
  const [visibleAIContainer, setVisibleAIContainer] = useState(visibleAiContainerFromQuery?(visibleAiContainerFromQuery==='true'):false);

  const [whereAmILevel, setWhereAmILevel] = useState(level);
  const [whereAmIBuilding, setWhereAmIBuilding] = useState(building);
  const [selectedFloor, setSelectedFloor] = useState(level);
  const [kioskLocation, setKioskLocation] = useState(1);

  const [eventStartDateData, setEventStartDateData] = useState({
    year: 2025,
    month: 3,
    day: eventStartDay
  });


  const [eventEndDateData, setEventEndDateData] = useState({
    year: 2025,
    month: 3,
    day: 14
  });


  useEffect(() => {
    if (kioskFid && kioskData[kioskFid]) {
      const data = kioskData[kioskFid];
      setLat(data.lat ||  41.89460301448591);
      setLong(data.long ||  -87.62175027218564);
      setRotation(data.rotation || 2.8);
      setZoom(data.zoom || 18);
      setPitch(data.pitch || 65);
      setBearing(data.bearing || 15);
      setLevel(data.level || 3);
      setWhereAmILevel(level);
      setBuilding(data.building || 12);
      setWhereAmIBuilding(building);
    }
  }, [kioskFid]);


  useEffect(() => {
    if (destFid && !hasPassedDestFidRef.current) {
      // Call any function or set up as needed for the first time `destFid` is passed
      hasPassedDestFidRef.current = true;
    }
  }, [destFid]);

  
  const showPopup = (poi, coordinates, cleanPopup = true,isMapClick=false) => {
    if (!poi) {
      if(popupState.poi){
        handleResetView(cleanPopup,isMapClick);
      } 
      const navigationViewController = window.PointrWebSDK.MapWidget.getInstance()?.getUiController().getNavigationViewController();
      window.PointrWebSDK.MapWidget.getInstance().getUiController().getMapViewController().hideRoute();
      navigationViewController.close();
      setPopupState({ poi: null, coordinates: null });
    
     
    } else {
      setPopupState({ poi, coordinates: (poi?.geometry?.type === 'Point') ? poi.geometry.coordinates : calculateMidPoint(poi.geometry.coordinates[0]) });
    }
  };
  const showCiscoSpacesPopup = () => {
    setCiscoSpacesPopup(true);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.PointrWebSDK) {
        setIsPointrSDKLoaded(true);
        clearInterval(interval);
      }
    }, 100); // Check every 100ms

    return () => clearInterval(interval);
  }, []);
  // Handler to hide the popup
  const hidePopup = () => {
    setPopupState({ poi: null, coordinates: null });
    handleResetView();
    setTriggerDirectionsPopup(false);
  };
  
  const badgeQrScanSuccess = async (badgeId) => {
    try{
    console.log("Badge Id received " + badgeId);
    showPopup(null, null, true, false);
    setQRScanBadgeInfoInput(null);
    let accessToken = await CiscoAiAuth.fetchAccessTokenForAttendee(eventId, badgeId);
    const attendeeInfo = await fetchAttendeeInfo(accessToken, eventId, { badgeId: badgeId },teaLogService);
    const userKey=attendeeInfo?.[0]?.userKey;     
    //const userFullName=attendeeInfo?.[0]?.firstName+" "+attendeeInfo?.[0]?.lastName;
    //const firstName=attendeeInfo?.[0]?.firstName
    //const lastName=attendeeInfo?.[0]?.lastName     
    //const dashboardPackage=attendeeInfo?.[0]?.dashboardPackage;     


    teaLogService.overrideConfiguration({"data":{"user":attendeeInfo?.[0]}})
    teaLogService.teaLogBadgeScanAction(badgeId,kioskLocation?kioskLocation:1);
    sendTrackingEventForCiscoAI(tenantId, attendeeInfo?.[0].userKey, "Badge Scan",eventName,attendeeInfo?.[0]);
    const recommendedEvents = await fetchRecommendedEvents(accessToken,eventId,attendeeInfo,"",constraintsLookUp,teaLogService);
    if(recommendedEvents == undefined|| recommendedEvents?.length==0){
      setShowFailedPopupCard(true);
      setShowPopupCard(false);
      return;
    }
    setRecommendationsInfo(recommendedEvents);
    setAttendeeInfo(attendeeInfo);
    setAttendeeUserToken(accessToken)
    setShowPopupCard(false);
    setShowAICard(true);
    }catch(error){
      console.log("Exception occured while processing badge");
      console.log(error)
      setShowFailedPopupCard(true);
      setShowPopupCard(false);
    }
    
  }

  useEffect(() => {
    // Fetch data from the API only once when the component mounts
    const getZones = async () => {
      try {

        const data = await fetchGsxData(tenantId);
        console.log("gsx" + data);
        if(data.zones){
          setIsZonesInfoPopulated(true);
        }
        setZonesInfo(data.zones);
        setHubwalksInfo(data.hubWalks);
        setFacilitiesData(data.facilities);

      } catch (err) {

        console.log(err);

      }
    };

    getZones();
   // intialiseQRScannerModule();
  }, []);
  // Simulate map loading
  useEffect(() => {
    // Simulate a delay for the map loading
    const mapLoadTimeout = setTimeout(() => {
      setIsMapLoaded(true);
      document.title = 'NM';
    }, 5000); // Adjust the delay as needed

    return () => clearTimeout(mapLoadTimeout);
  }, []);

  useEffect(() => {
    let intervalId;
  
    const fetchPoiUntilFound = async () => {
      if (map && destFid) {
        const poi = await map.getPoiManager().get(destFid);
        if (poi) {
          // Uncomment this line when ready to show the popup
          const uiController = map.getUiController();
          const mapViewController = uiController.getMapViewController();
          mapViewController.setLevel(poi.properties.lvl);
          mapViewController.highlightPoi(poi);
           showPopup(poi, poi?.geometry?.type === 'Point' ? poi.geometry.coordinates : calculateMidPoint(poi.geometry.coordinates[0]),false,false);
           clearInterval(intervalId); // Stop checking once the poi is found
        }
        
      }
    };
  
    // Set up polling to run fetchPoiUntilFound every 500ms (adjust as needed)
    intervalId = setInterval(fetchPoiUntilFound, 5000);
  
    return () => clearInterval(intervalId); // Clear interval on component unmount or when dependencies change
  }, [map, destFid]);


  useEffect(() => {
    const eventTypes = ["click", "mousemove", "keypress", "wheel", "gesturestart", "gesturechange", "gestureend", "touchmove", "touchstart", "touchend"];

    eventTypes.forEach(eventType => {
      window.addEventListener(eventType, handleActivity);
    });

    return () => {
      eventTypes.forEach(eventType => {
        window.removeEventListener(eventType, handleActivity);
      });
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  useEffect(() => { }, [isActive]);


  const handleActivity = (event) => {
    setIsActive(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsActive(false);
      console.log("No activity detected for 2 minutes." + event.type);
    }, 180000); // 3 minutes
  };


  const handleSearch = async (searchInput) => {
    hidePopup();
    const uiController = map.getUiController();
    const mapViewController = uiController.getMapViewController();
    const mapView = mapViewController.getView();
    mapView.setLayoutProperty("rmaps-symbol_selected_ptr", 'icon-image', 'green_marker');

    console.log(searchInput);
    let valueAfterTilde;
    let poiFid = searchInput?.fId;
    if (searchInput?.type === 'session') {
      poiFid = searchInput?.poiFId;
    }else if((searchInput?.type === 'exhibitor')){
      poiFid = searchInput?.poiFId;
    }
    if (poiFid?.includes('~')) {
      valueAfterTilde = poiFid.split('~')[1];
    } else {
      valueAfterTilde = poiFid;
    }
    const poi = await map.getPoiManager().get(valueAfterTilde);
    if (poi) {
      map.unhighlight();
      mapViewController.setLevel(poi.properties.lvl);
      mapViewController.highlightPoi(poi);
      map.hidePoiDetails(poi);

      if (poi?._geometry?.coordinates[0]) {
        const latLong = (poi.geometry.type === 'Point') ? {
          lat: poi.geometry.coordinates[1],
          lng: poi.geometry.coordinates[0]
        } : calculateMidPoint(poi?._geometry?.coordinates[0]);

        //updateLayerFilterForSingleFeature(mapView, searchInput);
        mapView.map.flyTo({
          center: [latLong.lng, latLong.lat],
          zoom: 20, pitch: pitch, bearing: bearing, speed: 0.4
        });
        if (searchInput.type === 'session') {
          poi._properties.isSession = true;
          poi._properties.sessionsInfo = [searchInput];
          poi._properties.sessionStart= searchInput?.utcStartTime;

        }
        showPopup(poi, latLong);
        manageLayers(map?.getUiController().getMapViewController().getView(),poi?._properties?.bid,poi?._properties?.lvl)
        if(poi?._properties?.lvl==whereAmILevel){
          markCurrentPosition(map, long, lat, rotation, true, pitch, bearing, whereAmIBuilding, whereAmILevel, whereAmIBuilding, whereAmILevel, zoom, whereAmIScale);

        }else{
          removeCurrentPosition(map.getUiController().getMapViewController().getView());
        }
      }
    }
  };

  useEffect(() => {
    if (searchInput) {
      handleSearch(searchInput);
    }
  }, [searchInput]);

  const intialiseQRScannerModule = async () =>{
      console.log("Initiliazing the QR code scanner");
      let hashes = getHashes(["username", "password", "ipAddress", "location"]);
      setKioskLocation(hashes?.location? hashes.location : 1)
      await initializeXAPIScanner(window.jsxapi,hashes,setQRScanBadgeInfoInput);
  }

  useEffect(() => {
    console.log("QR Input received "+qrScanBadgeInfoInput);
    if (qrScanBadgeInfoInput) {
      if(!showAICard && !showFaqList && showPopupCard){
        badgeQrScanSuccess(qrScanBadgeInfoInput);
        showAiLoader(true);
        setQRScanBadgeInfoInput(null);
      }else{
         console.error("Already Attendee is using the AI or no yet launched")
         setQRScanBadgeInfoInput(null);
      }
    }
  }, [qrScanBadgeInfoInput]);


  useEffect(() => {
    console.log("showAiLoader received "+aiLoader);
    if (aiLoader) {
      showLoader();
    }else{
      hideLoader();
    }
  }, [aiLoader]);


  useEffect(() => {
    console.log("showAICard received "+showAICard);
    if (!showAICard) {
      setShowFaqList(0);
      setQRScanBadgeInfoInput(null);
    }
  }, [showAICard]);

  // Function to create and show the loader
  function showLoader() {
    // Create and style the overlay element
    const overlay = document.createElement("div");
    overlay.id = "ai-overlay"; // Set the id
    overlay.className = "ai-overlay"; // Set the class name
    document.body.appendChild(overlay);

    // Create and style the loader element
    const loader = document.createElement("div");
    loader.id = "ai-loader"; // Set the id
    loader.className = "ai-loader"; // Set the class name
    document.body.appendChild(loader);

    // Display the loader and overlay
    if (loader && overlay) {
      overlay.style.display = "block";
      loader.style.display = "block";
    }
  }


  // Function to hide and remove the loader
  function hideLoader() {
    const loader = document.getElementById("ai-loader");
    const overlayloader = document.getElementById("ai-overlay");

    if (loader && overlayloader) {
      loader.style.display = "none";
      document.body.removeChild(loader);

      overlayloader.style.display = "none";
      document.body.removeChild(overlayloader);

    }
  }
  const handleResetView = (cleanPopup = false,isMapClick=false) => {
    setShowAICard(false);
    setShowFaqList(false);
    setTriggerDirectionsPopup(false);
    setSelectedFloor(whereAmILevel)
    handleReset(long ? long : -71.20129185010097, lat ? lat : 42.18882997249821, rotation ? rotation : -4.5, 18, true, cleanPopup,isMapClick, pitch, bearing, whereAmIBuilding, whereAmILevel, centerLong, centerLat, whereAmIScale);
  };


  const handleResetViewButton = (cleanPopup = false) => {
    setPopupState({ poi: null, coordinates: null });
    handleResetView();
  };

  const handleResetViewButtonInitialZoom = (cleanPopup = false) => {
    setPopupState({ poi: null, coordinates: null });
    setSelectedFloor(whereAmILevel)
    handleResetView();
  //handleReset(long ? long : -115.1782890405586, lat ? lat : 36.088308032921276, rotation ? rotation : -4.5, 17, true, cleanPopup,false, pitch, bearing, building, level);

    const uiController = map.getUiController();
    const mapViewController = uiController.getMapViewController();
    const mapView = mapViewController.getView();
    mapView.map.flyTo({
      center: [long, lat],
      zoom: 18,
      bearing: bearing,
      pitch: pitch,
      speed:0.4
    });
  };

  return (
    <div className="main-container">

      {isPointrSDKLoaded && <MapComponent showPopup={showPopup} tenantId={tenantId}
        locationId={locationId} siteExternalIdentifier={siteExternalIdentifier} lat={lat} long={long} zoom={zoom} pitch={pitch} bearing={bearing} rotation={rotation} eventName = {eventName} whereAmILevel={parseInt(whereAmILevel)} whereAmIBuilding={parseInt(whereAmIBuilding)} defaultBuilding={parseInt(building)} defaultLevel={parseInt(level)} setBuilding={setBuilding} setLevel={setLevel} timeZone={timeZone} eventStartDateData={eventStartDateData} centerLatLong={[centerLong,centerLat]} 
        setTriggerDirectionsPopup={setTriggerDirectionsPopup} whereAmIScale={whereAmIScale}/>}
      {isMapLoaded && (
        
        <>
          {handleWhereAmI(map,long,lat,rotation,pitch,bearing,whereAmILevel, whereAmIBuilding)}
          <HeaderContainer
            showCiscoSpacesPopup={showCiscoSpacesPopup} timeZoneCity={timeZoneCity} 
            eventStartDateData = {eventStartDateData} eventEndDateData={eventEndDateData}  
            handleResetView={handleResetViewButton}  eventLogoName={eventLogoName} 
            eventName={eventName} defaultLevel={parseInt(level)} 
            defaultBuilding = {parseInt(building)} setBuilding={setBuilding} 
            setLevel={setLevel} pitch={pitch} 
            bearing={bearing} lat={lat} long={long} 
            rotation={rotation}
            eventTitle={eventTitle}
            eventSubTitle={eventSubTitle}
            eventTimeZone={timeZone}
            defaultBuildingTitle={"Cisco - NM"}
            buildingInfo={buildingInfo}
            whereAmIScale={whereAmIScale}
            displayDay ={false}/>
          {zonesInfo &&
            <LeftContainerNM
              zoneData={zonesInfo} showPopup={showPopup} hidePopup={hidePopup} tenantId={tenantId}
              locationId={locationId} qrCodeExpiresAt={qrCodeExpiresAt}
              whereAmIBuilding={whereAmIBuilding}
              whereAmILevel={whereAmILevel}
              defaultLevel={parseInt(level)} 
              defaultBuilding = {parseInt(building)}
              handleResetView={handleResetViewButton}
              setBuilding={setBuilding}
              setLevel={setLevel} 
              lat={lat}
              long={long}
              rotation={rotation}
              pitch={pitch}
              bearing={bearing}
              showLevelSelector={true}
              isZonesInfoPopulated={isZonesInfoPopulated}
              isDestFidPopulated={destFid?true:false}
              selectedFloor={selectedFloor}
              setSelectedFloor={setSelectedFloor}
              buildingInfo={buildingInfo}
              defaultBuildingTitle={defaultBuildingTitle}
              centerLatLong={[centerLong,centerLat]}
              eventName={eventName}
              floorColourMapping={floorColourMapping}
              floorNameMapping={floorNameMapping}
              whereAmIScale={whereAmIScale}
               />}
          {isPointrSDKLoaded && 
          <RightContainer
            hubwalksData={hubwalksInfo} 
            facilitiesData={facilitiesData} 
            pitch={pitch} 
            bearing={bearing} 
            centerLong={centerLong} 
            centerLat={centerLat}
            visibleAIContainer={visibleAIContainer}
            eventId={eventId}
            tenantId={tenantId}
            setShowPopupCard={setShowPopupCard}
            showAICard={showAICard}
            setShowAICard={setShowAICard}
            showPopup={showPopup}
            recommendationsInfo={recommendationsInfo}
            setRecommendationsInfo={setRecommendationsInfo}
            attendeeUserToken={attendeeUserToken}
            attendeeInfo={attendeeInfo}
            constraintsLookUp={constraintsLookUp}
            teaLogService={teaLogService}
            setShowFaqList={setShowFaqList}
            showFaqList={showFaqList}
            setTriggerDirectionsPopup={setTriggerDirectionsPopup}
            triggerDirectionsPopup={triggerDirectionsPopup}
            setPopupState={setPopupState}
            showAiLoader={showAiLoader}
            facilityZoomTo={18}
            />}
          {(!isActive &&
          /** <CountdownTimer
              initialMinutes={0}
              initialSeconds={10}
              resetTimer={isActive} // Pass isActive as a prop to reset the timer
              showPopup={showPopup}
            /> */
            <Screensaver inactivityTimeout={1000} flipInterval={3000} showPopup={showPopup} ciscoSpacesPopupImage={ciscoSpacesPopupImage} lat={lat} long={long} zoom={zoom} rotation={rotation} pitch={pitch} bearing={bearing} whereAmILevel={whereAmILevel} centerLong={centerLong} centerLat={centerLat} setShowAICard={setShowAICard} setShowPopupCard={setShowPopupCard} whereAmIScale={whereAmIScale} displayScreenSaver={false}  setShowSearch={setShowSearch}/>
           
          )}
          {(showFaqList==1) && <AIFAQListContainer setShowFaqList={setShowFaqList} showFaqList={showFaqList} setShowAICard={setShowAICard} showAICard={showAICard} setShowPopupCard={setShowPopupCard}/>}
          {showSearch && (
            <SearchPopup
              setSearchInput={setSearchInput}
              setShowSearch={setShowSearch}
              map={map}
              tenantId={tenantId}
              placeholder={"Search for points of interest and other facilities"}
              timeZone={timeZone}
              eventStartDateData={eventStartDateData}
            />
          )}
          {showPopupCard && (
            <div className="ai-popup-overlay">
              <div className="ai-popup-overlay-popup">
                <div className="ai-popup-overlay-popup-card">
                 
                  <img src={ciscoAILogo} class="ai-popup-overlay-popup-card-logo" />
                  <div className="ai-popup-overlay-popup-card-logo-name">
                  You have activated <br/>Cisco AI Assistant.
                  </div>
                  <div className="ai-popup-overlay-popup-card-title">
                  Now, scan the front of your<br/>badge on the scanner to begin<br/>your customized journey.​
                  </div>
                  <img src={ciscoAIQrPlaceHolderLogo} className="ai-popup-overlay-popup-card-qr-place-holder" onClick={()=>{badgeQrScanSuccess("1730740293847001Zs8f")}}  />
                  <div className="ai-popup-overlay-popup-card-bottom-button">
                  <img src={ciscoHelpbutton} className="ai-popup-overlay-popup-card-bottom-button-help"  onClick={() => {setShowPopupCard(false);setShowFailedPopupCard(false); setShowFaqList(1); }}/>

                  <img src={ciscoClosebutton} className="ai-popup-overlay-popup-card-bottom-button-close" onClick={() => setShowPopupCard(false)}/>
                  </div>
                </div>
              </div>
            </div>
          )}
           {showFailedPopupCard && (
            <div className="ai-popup-overlay">
              <div className="ai-popup-overlay-popup">
                <div className="ai-popup-overlay-popup-card">
                 
                  <img src={ciscoAILogo} class="ai-popup-overlay-popup-card-logo" />
                  <div className="ai-popup-overlay-popup-card-logo-name">
                  You have activated <br/>Cisco AI Assistant.
                  </div>
                  <div className="ai-popup-overlay-popup-card-title">
                  There was an error<br/>scanning your badge.​
                  </div>
                  <img src={ciscoAIQrPlaceHolderFailedLogo} className="ai-popup-overlay-popup-card-qr-place-holder"/>
                  <div className="ai-popup-overlay-popup-card-bottom-scan-again-button" onClick={()=>{ setShowFailedPopupCard(false); setShowPopupCard(true);}}>
                    Scan again
                  </div>

                  <div className="ai-popup-overlay-popup-card-bottom-button">
                  <img src={ciscoHelpbutton} className="ai-popup-overlay-popup-card-bottom-button-help"  onClick={() => {setShowPopupCard(false); setShowFailedPopupCard(false); setShowFaqList(1)}}/>

                  <img src={ciscoClosebutton} className="ai-popup-overlay-popup-card-bottom-button-close" onClick={() => {setShowPopupCard(false); setShowFailedPopupCard(false);}}/>
                  </div>
                </div>
              </div>
            </div>
          )}
          {popupState.poi && (
            <CustomPopup
              poi={popupState.poi}
              coordinates={popupState.coordinates}
              tenantId={tenantId}
              locationId={getLocationId(popupState.poi)}
              onCancel={hidePopup}
              setPopupState={setPopupState}
              source={"poiClick"}
              lat={lat}
              long={long}
              building={building}
              level={level}
              rotation={rotation}
              bearing={bearing}
              pitch={pitch}
              whereAmIBuilding={whereAmIBuilding}
              whereAmIlevel={whereAmILevel}
              qrCodeExpiresAt={qrCodeExpiresAt}
              destFid={hasPassedDestFidRef.current ? undefined : destFid} 
              setBuilding={setBuilding}
              setLevel={setLevel}
              eventStartDate={eventStartDateData}
              eventTimeZone={timeZone}
              setSelectedFloor={setSelectedFloor}
              triggerDirectionsPopup={triggerDirectionsPopup}
              setTriggerDirectionsPopup={setTriggerDirectionsPopup}
              whereAmIScale={whereAmIScale}
              navigationZoom={19}
            />
          )}

          { aiLoader && <div  class="ai-overlay" id="ai-overlay" >
                    <div class="ai-loader" id="ai-loader" ></div>
                </div>}
          <FooterContainer
            setShowSearch={setShowSearch}
            handleResetView={handleResetViewButtonInitialZoom}
            long={long}
            lat={lat}
            rotation={rotation}
            pitch={pitch}
            bearing={bearing}
            whereAmIBuilding={parseInt(whereAmIBuilding)}
            whereAmILevel={parseInt(whereAmILevel)}
            setSelectedFloor={setSelectedFloor}
            whereAmIScale={whereAmIScale}
          />
        </>
      )}
    </div>
  );
};

export default NMDemoMainContainer;
